import { FC, useContext, useEffect, useState } from 'react';
import { AiFillCheckSquare } from 'react-icons/ai';
import { Button, Icon } from '@chakra-ui/react';

import { useUserData } from '~/core/shared/contexts/UserContext';
import { DocumentListContext } from '../application';

export const MyDealsOnlyButton: FC = () => {
  const { setFilter, filters } = useContext(DocumentListContext);
  const { user } = useUserData();
  const [myDealsOnlyChecked, setMyDealsOnlyChecked] = useState<boolean>(false);

  useEffect(() => {
    const currentValue = filters.assignee || '';

    if (user) {
      const newValue = myDealsOnlyChecked ? user.id : '';
      if (newValue !== currentValue) {
        setFilter('assignee', newValue);
      }
    }
  }, [myDealsOnlyChecked, user]);

  useEffect(() => {
    if (user) {
      setMyDealsOnlyChecked(filters.assignee === user.id);
    }
  }, [filters.assignee, user]);

  return (
    <Button
      borderColor="black"
      color="black"
      colorPalette="white"
      fontSize="sm"
      fontWeight="bold"
      onClick={() => setMyDealsOnlyChecked((value) => !value)}
      size="xs"
      variant="outline"
    >
      {myDealsOnlyChecked && (
        <Icon as={AiFillCheckSquare} color="primary.500" />
      )}
      My deals only
    </Button>
  );
};
